exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tableCard--1tu7E {\n    margin: 16px;\n}\n", ""]);

// Exports
exports.locals = {
	"tableCard": "tableCard--1tu7E"
};